import { Switch } from '@headlessui/react';

interface SwitchToggleProps {
    label?: string;
    enabled: boolean;
    onChange: (enabled: boolean) => void;
}

export default function SwitchToggle({ label, enabled, onChange, ...rest }: SwitchToggleProps) {
    return (
        <Switch.Group>
            <div className="flex items-center space-x-3">
                <Switch
                    checked={enabled}
                    onChange={onChange}
                    className="bg-white relative inline-flex flex-shrink-0 h-[28px] w-[68px] border-2 border-gray-300 rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75 "
                    {...rest}
                >
                    <span className="sr-only">Use setting</span>
                    <span
                        aria-hidden="true"
                        className={`${enabled ? 'translate-x-9 bg-brand' : 'translate-x-0 bg-gray-500'}
            relative pointer-events-none inline-block h-[34px] w-[34px] top-[-4px] left-[-2px] rounded-full shadow-lg transform ring-0 transition ease-in-out duration-200`}
                    />
                </Switch>
                {label && <Switch.Label className="cursor-pointer">{label}</Switch.Label>}
            </div>
        </Switch.Group>
    );
}
